export const removeComma = (value: string) => {
  return value.replace(/[,a-zA-Z]/g, '');
};
